import PROFILE from './info/profile'
import LINE_SPECIAL from './info/lineSpecial'

const COLLECTION_ICONS_DIR = '/static/img/recommend/lp/common/collection_icons/'
export const colorScheme = {
  keyColor: '#FF6AD5',
  second: '#90D7FF',
  gradStart: '#90D7FF',
  gradEnd: '#FBC1FA',
  buttonBackground: 'linear-gradient(90deg, #93c0f4 2%, #c296f9 52.09%, #ff6ab2 98.17%)',
  baseBg: '#FF6AB2', // ヘッダ用のBGとして使用(指定がない場合はgradStart,gradEndを使用し標準パラメータでグラデーションを描画)
  infoBg: '#FFFBE3',
  messBg: '#e9f7ff',
  profileKeyColor: '#FF6AB2',
}

const pathCommon = '/static/img/recommend/lp/common/'
const pathCounselor = '/static/img/recommend/lp/ottimo/'
// const deco = `${pathCounselor}castle.png`
const donuts = `${pathCounselor}treasurebox.png`
const castle = `${pathCounselor}castle.png`
const counselor = `${pathCounselor}counselor_dotchar.png`

const SUBSC_MENU_NUM = '? 利用する時に訂正してください' //サブスクメニュー数

const hero = {
  pc: `${pathCounselor}top_sp_20221003.webp`,
  sp: `${pathCounselor}top_sp_20221003.webp`,
  fallback_pc: `${pathCounselor}top_sp_20221003.png`,
  fallback_sp: `${pathCounselor}top_sp_20221003.png`,
  alt: '占い天使オッティモちゃん'
}

const about = {
  // deco: deco,
  img: `${pathCounselor}about.webp`,
  headline: '占い天使オッティモちゃんとは',
  text: '人間界をハピネスエナジーで満たすために、ぐんぐり天界からやってきた「占い天使」。<br>奇抜なビジュアルとは裏腹に、多くの占術を扱う実力派で、TV、ラジオなどメディア出演実績も多数。',
}

const fortune = {
  // deco: deco,
  headline: '宇宙占術RPU',
  text: 'キャラタイプから、あなたに与えられた能力を見出す占い。まるで冒険を進めるように、毎日を突き進む秘訣を教えます。',
  kira: donuts,
  castle: castle,
  you: {
    headline: '宇宙占術RPUで知る<br>あなたのこと',
    text: '宇宙占術RPUは、役職タイプからあなたの本当の強みを見つけます。',
    comment: '誰だって生まれつき特別な能力を与えられているんだよ！<br>それを知ることから、RPUは始まるんだ！',
    counselorImage: counselor,
    avatar: `${pathCounselor}avatar.png`,
    sample: [
      {
        icon: `${pathCounselor}img_kekka1.png`,
        label: '勇者',
        text: '「言葉の力」を与えられている主人公属性',
      },
      {
        icon: `${pathCounselor}img_kekka2.png`,
        label: '賢者',
        text: '「探求心」を与えられている職人気質',
      },
    ],
    advice: '自分の運命を組み立てて、<br>幸せをつかみに行きましょう。',
  },
  method: {
    headline: '宇宙占術RPUで<br>幸せへの近道を<br>見つけましょう',
    text: 'あなたに与えられた「能力」が分かれば、自分に合った生き方が見えてきます。<br>まだ活かしきれていないあなたの「能力」を引き出しましょう。',
    counselorImage: counselor,
    avatar: `${pathCounselor}avatar.png`,
    sample: [
      {
        icon: `${pathCounselor}img_kekka1.png`,
        label: '勇者',
        text: '新たな道を切り拓いていく',
      },
      {
        icon: `${pathCounselor}img_kekka2.png`,
        label: '賢者',
        text: 'まわりを客観的に分析できる',
      },
    ],
    advice: 'あなたの良いところ<br>オッティモが<br>教えるよ！',
  },
  free: {
    text: '自分のタイプが気になった方は、こちらから診断できますよ',
    img: `${pathCounselor}counselor2.png`,
  }
}

const review = {
  // deco: deco,
}

const menu = {
  title: '<img src="/static/img/recommend/lp/ottimo/menulist_title.png" style="width: 62.4%;max-width: 292px;">',
  // deco: deco,
}

const uTV = {
  // deco: deco,
  counselorImage: `${pathCounselor}counselor3.png`,
  lead: 'あなたがもっと<br>幸せになるために',
  // resultBottomCap: `${PROFILE.name}の占いが<br>月額528円（税込）で<br>${SUBSC_MENU_NUM}メニュー占い放題！`
  resultBottomCap: `TVで話題の占いが<br>月額528円（税込）で<br>2000メニュー占い放題！`
}

export const reviews = [
  { icon: `${pathCounselor}icon_review1.png`, review: 'もしかして昔から友達だった？って言うくらいズバズバ当てられました' },
  { icon: `${pathCounselor}icon_review2.png`, review: '確かにそうだなって思うところもあるし、自分のことを褒めてもらえてるようですごくhappyになれました' },
  { icon: `${pathCounselor}icon_review3.png`, review: 'とにかく可愛い。可愛く教えてくれるから、読みながらありがとうって声が出てしまった。' },
]

const title = {
  subTitle: 'キャラタイプであなたの能力がわかる',
  title: 'オッティモちゃんの<br>宇宙占術RPU',
}

const fortuneResult = {
  lead: 'あなたのキャラタイプは',
  type: 'あなたの能力と冒険の進め方',
}

const snsShare = {
  lead: 'キャラタイプをシェアする',
}

const leadMenu = {
  // deco: deco,
  counselorImage: `${pathCounselor}counselor4.png`,
  comment: '<b>あなたのキャラタイプはわかったかな？<br><br>[冒険者のあなたの特徴]を読めば、あなたの人柄がみえてくるよ☆</b>',
  // sample1: `${pathCounselor}sample1.png`,
  // sample2: `${pathCounselor}sample2.png`,
  // lead: `${pathCounselor}leadMenu_text.png`,
  // lead: 'あなたのこと、<br>大切な人とのことを<br>詳しく見るなら',
}

const aboutType = {
  // deco: deco,
  // counselorImage: `${pathCounselor}counselor3.png`,
  lead: '冒険者のあなたの特徴',
}

const leadSubsc = {
  // deco: deco,
}

const advice = {
  // deco: deco,
  counselorImage: `${pathCounselor}counselor5.png`,
}

const title2 = {
  // deco: deco,
  subTitle: '＼あなたの周りの人は何タイプ？／',
  title: 'オッティモちゃんの<br>宇宙占術RPUで<br>占ってみよう',
}

const floatingBanner = {
  enable: false,
  title: '<span class="name">法演</span>の<span class="emphasis">MITSURI</span>で',
  freeBtnFace: '無料で占う',
  colors: {
    background: '#f9f5ed',
    baseText: colorScheme.baseBg,
    emphasis: '#4bcb7b',
    decos: colorScheme.second,
    freeBtn: '#4bcb7b',
    freeBtnBg: 'white',
  }
}

const menuDetails = {
  noIndividualed: true,
  colors: {
    headBg: colorScheme.baseBg,
    headColor: 'white',
    baseBg: 'white',
    baseColor: colorScheme.baseBg,
  },
  contents: [
    { icon: `${COLLECTION_ICONS_DIR}icon_collection1.png`, description: '運命の人の顔の特徴は「XX」<br>名前は「○」がつく人' },
    { icon: `${COLLECTION_ICONS_DIR}icon_collection2.png`, description: 'あなたが仕事で成功を手にするきっかけ' },
    { icon: `${COLLECTION_ICONS_DIR}icon_collection3.png`, description: '運命の人とは、どんな形で<br>結婚に至る？' },
    { icon: `${COLLECTION_ICONS_DIR}icon_collection4.png`, description: 'あなたが持っている財運と<br>それを最大限に活かす稼ぎ方' },
    { icon: `${COLLECTION_ICONS_DIR}icon_collection5.png`, description: 'あなたが知っておくべき<br>「弱点」とその「向き合い方」' },
    { icon: `${COLLECTION_ICONS_DIR}icon_collection6.png`, description: 'これまでにあなたが人生で<br>築き上げてきたもの' },
  ],
}

const tabedMenu = {
  color: {
    baseColor: '#4bcb7b',
    itemFont: colorScheme.keyColor,
    framecolor: colorScheme.keyColor,
  }
}

const lineBanner = {
  bannerUrl: '/static/img/recommend/lp/banner/ottimo_line_20220316.png'
}

export const information = {
  name: PROFILE.name, // ※互換のため残すが以降についてはprofile.nameを使用すること
  mainMethod: PROFILE.mainMethod, // ※互換のため残すが以降についてはprofile.mainMethodを使用すること
  profile: PROFILE,
  lineSpecial: LINE_SPECIAL,
  hero,
  about,
  fortune,
  review,
  reviews,
  menu,
  uTV,
  title,
  fortuneResult,
  snsShare,
  leadMenu,
  aboutType,
  leadSubsc,
  advice,
  title2,
  floatingBanner,
  menuDetails,
  tabedMenu,
  lineBanner,
}



// WEBPACK FOOTER //
// ./resources/assets/js/utvStore/components/recommend/lp/counselor/ottimo/counselorInfos.js